import type { IconSvgObject } from './types';

const CaseLowerIcon: IconSvgObject = [
  ["path", { d: "M6.5 17C8.433 17 10 15.433 10 13.5C10 11.567 8.433 10 6.5 10C4.567 10 3 11.567 3 13.5C3 15.433 4.567 17 6.5 17Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17.5 17C19.433 17 21 15.433 21 13.5C21 11.567 19.433 10 17.5 10C15.567 10 14 11.567 14 13.5C14 15.433 15.567 17 17.5 17Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M10 10V17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M14 7V17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default CaseLowerIcon;
